/* eslint-disable no-undef */
/* Show mega menu with hover */

let isPetternetImagesSet = false
let gettingPetternetImages = false

if ($(window).width() > 767) {
  $('.has-mega-menu').on('mouseenter', function () {
    /* hover in */
    var width
    var windowWidth = $(window).width()
    var leftOffset = $(this).offset().left

    if ($(window).width() > 1400) {
      width = windowWidth - leftOffset
      $(this).find('ul.sub-menu').css('left', '0px')
    } else {
      width = windowWidth
      $(this).find('ul.sub-menu').css('left', -1 * leftOffset + 'px')
    }

    $(this).find('ul.sub-menu').width(width).css('display', 'block')
    addShowMega(this)
  }).on('mouseleave', function () {
    /* hover out */
    $(this).removeClass('show-mega')
    $(this).find('ul.sub-menu').css('display', 'none')
  })

  $('body').on('click', '.show-mega a', function () {
    $(this).parents('.has-mega-menu').removeClass('show-mega')
    $(this).parents('ul.sub-menu').css('display', 'none')
  })

  $('.mega-menu-peltituotteet').on('mouseenter', function () {
    var menuContent = $('#mega-menu-peltituotteet').html()
    $(this).find('ul.sub-menu').html(menuContent)
  })
  $('.mega-menu-ratkaisu').on('mouseenter', function () {
    var menuContent = $('#mega-menu-ratkaisu').html()
    $(this).find('ul.sub-menu').html(menuContent)
  })
  $('.mega-menu-petternet').on('mouseenter', function () {
    var menuContent = $('#mega-menu-petternet').html()
    $(this).find('ul.sub-menu').html(menuContent)
  })
}

function addShowMega (megaMenu) {
  // timeout needed for the animation to work
  setTimeout(function () {
    $(megaMenu).addClass('show-mega')
  }, 10)
}

// get/set Petternet images only in desktop
if ($(window).width() > 767) {
  getPetternetImages()
}

// get/set Petternet images when resizing browser
$(window).resize(function () {
  if ($(window).width() > 767 && !isPetternetImagesSet && !gettingPetternetImages) {
    getPetternetImages()
  }
})

// get and insert images in PetterNET menu link
function getPetternetImages () {
  gettingPetternetImages = true
  let arrow = $.get(myVariables.petternet_nuoli)
  let line = $.get(myVariables.petternet_viiva)

  $.when(arrow, line).done(function (dataArrow, dataLine) {
    $('#site-navigation .mega-menu-petternet > a').append($('<span>', { class: 'petternet-arrow', html: $(dataArrow)[0].documentElement }))
    $('#site-navigation .mega-menu-petternet > a').append($('<span>', { class: 'petternet-line', html: $(dataLine)[0].documentElement }))
    isPetternetImagesSet = true
  })
}
